import { RestRequestType } from './../shared/enums/rest-request-type.enum';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { RestRequestResponse } from "../shared/interfaces/rest-request-response";

export class RestAPIMethods {
  cacheSubject = new Subject<any>();
  private readonly payloadData = {
    specVersion: '1.0.0',
    source: 'intellija-ui',
    id: 'C234-1234-1234',
    dataContentType: 'application/json'
  };

  constructor(private http: HttpClient, private origin: string) {}

  get<T = any>(endpoint: string, options?:
    { headers?: HttpHeaders } | { [header: string]: string | string[] }): Observable<T> {

    return this.http.get<T>(this.getURL(endpoint), options || {}).pipe(first());
  }
  post<R = any>(endpoint, type: RestRequestType, payload?: any,
    options?: { headers?: HttpHeaders } | { [header: string]: string | string[] },
  ) {
    payload = payload ? this.buildPayload(payload, type) : null;
    return this.http.post<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  put<R = any>(endpoint, type: RestRequestType, payload?: any,
    options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
    payload = this.buildPayload(payload, type);
    return this.http.put<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  patch<R = any>(endpoint, type: RestRequestType, payload?: any,
    options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
    payload = this.buildPayload(payload, type);
    return this.http.patch<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  delete<R = any>(endpoint,
    options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
      return this.http.delete<RestRequestResponse<R>>(this.getURL(endpoint), options || {});
  }

  getURL(endpoint): string {
    return environment.BASE_URL + this.origin + endpoint;
  }

  private buildPayload(data: any, type) {
    return {
      ...this.payloadData,
      time: new Date().toISOString(),
      type,
      data
    };
  }

}
